import React from "react";
import User from "../app/modules/assets/icons/User/user.component";
import Company from "../app/modules/assets/icons/Company/company.component";
import Group from "../app/modules/assets/icons/Group/group.component";

export const settingsOptions = 
 [
    {
      title: "Cuenta",
      description: "Actualiza la información de tu cuenta",
      path: "/setting/account",
      icon: <Company />,
      name: "account",
    },
    {
      title: "Usuarios",
      description: "Invita usuarios y asigna roles de trabajo",
      path: "/setting/users",
      icon: <User />,
      name: "user",
    },
    {
      title: "Grupos",
      description: "Encuentra los grupos de trabajo y añade colaboradores",
      path: "/setting/groups",
      icon: <Group />,
      name: "group",
    },
  ]

